module.exports = __webpack_public_path__ + "img/Diagnosis - White - Selected.bd182927.png";